import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCursorDrag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 18,
	viewBox: "0 0 17 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "pointing",
		filter: "url(#filter0_d_687_12162)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Shape",
				d: "M4.26987 12.28C3.98987 11.92 3.63987 11.19 3.02987 10.28C2.67987 9.78 1.81987 8.83 1.55987 8.34C1.37244 8.04223 1.31806 7.67966 1.40987 7.34C1.56683 6.69421 2.17943 6.26582 2.83987 6.34C3.35067 6.44261 3.8201 6.69297 4.18987 7.06C4.44805 7.30318 4.68554 7.56742 4.89987 7.85C5.05987 8.05 5.09987 8.13 5.27987 8.36C5.45987 8.59 5.57987 8.82 5.48987 8.48C5.41987 7.98 5.29987 7.14 5.12987 6.39C4.99987 5.82 4.96987 5.73 4.84987 5.3C4.72987 4.87 4.65987 4.51 4.52987 4.02C4.41104 3.53858 4.31758 3.05124 4.24987 2.56C4.12383 1.93171 4.21553 1.27922 4.50987 0.710004C4.85927 0.381373 5.3718 0.294636 5.80987 0.490004C6.25047 0.81534 6.57897 1.26966 6.74987 1.79C7.01194 2.43039 7.18683 3.10307 7.26987 3.79C7.42987 4.79 7.73987 6.25 7.74987 6.55C7.74987 6.18 7.67987 5.4 7.74987 5.05C7.81923 4.68513 8.07283 4.38232 8.41987 4.25C8.71768 4.15863 9.03272 4.13808 9.33987 4.19C9.64991 4.25482 9.92454 4.43315 10.1099 4.69C10.3416 5.2734 10.4701 5.8926 10.4899 6.52C10.5167 5.97059 10.6107 5.42653 10.7699 4.9C10.937 4.66455 11.181 4.49479 11.4599 4.42C11.7905 4.35956 12.1293 4.35956 12.4599 4.42C12.731 4.51063 12.9681 4.68152 13.1399 4.91C13.3516 5.44035 13.4798 6.00035 13.5199 6.57C13.5199 6.71 13.5899 6.18 13.8099 5.83C13.9242 5.4906 14.2109 5.23797 14.562 5.16728C14.9131 5.09659 15.2752 5.21857 15.512 5.48728C15.7488 5.75599 15.8242 6.1306 15.7099 6.47C15.7099 7.12 15.7099 7.09 15.7099 7.53C15.7099 7.97 15.7099 8.36 15.7099 8.73C15.6734 9.31518 15.5932 9.89681 15.4699 10.47C15.2958 10.9771 15.0536 11.4582 14.7499 11.9C14.2643 12.44 13.8631 13.0502 13.5599 13.71C13.4846 14.0378 13.451 14.3738 13.4599 14.71C13.4589 15.0206 13.4992 15.33 13.5799 15.63C13.171 15.6732 12.7587 15.6732 12.3499 15.63C11.9599 15.57 11.4799 14.79 11.3499 14.55C11.2856 14.4211 11.1539 14.3397 11.0099 14.3397C10.8658 14.3397 10.7342 14.4211 10.6699 14.55C10.4499 14.93 9.95987 15.62 9.61987 15.66C8.94987 15.74 7.56987 15.66 6.47987 15.66C6.47987 15.66 6.65987 14.66 6.24987 14.3C5.83987 13.94 5.41987 13.52 5.10987 13.24L4.26987 12.28Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.26987 12.28C3.98987 11.92 3.63987 11.19 3.02987 10.28C2.67987 9.78 1.81987 8.83 1.55987 8.34C1.37244 8.04223 1.31806 7.67966 1.40987 7.34C1.56683 6.69421 2.17943 6.26582 2.83987 6.34C3.35067 6.44261 3.8201 6.69297 4.18987 7.06C4.44805 7.30318 4.68554 7.56742 4.89987 7.85C5.05987 8.05 5.09987 8.13 5.27987 8.36C5.45987 8.59 5.57987 8.82 5.48987 8.48C5.41987 7.98 5.29987 7.14 5.12987 6.39C4.99987 5.82 4.96987 5.73 4.84987 5.3C4.72987 4.87 4.65987 4.51 4.52987 4.02C4.41104 3.53858 4.31758 3.05124 4.24987 2.56C4.12383 1.93171 4.21553 1.27922 4.50987 0.710004C4.85927 0.381373 5.3718 0.294636 5.80987 0.490004C6.25047 0.81534 6.57897 1.26966 6.74987 1.79C7.01194 2.43039 7.18683 3.10307 7.26987 3.79C7.42987 4.79 7.73987 6.25 7.74987 6.55C7.74987 6.18 7.67987 5.4 7.74987 5.05C7.81923 4.68513 8.07283 4.38232 8.41987 4.25C8.71768 4.15863 9.03272 4.13808 9.33987 4.19C9.64991 4.25482 9.92454 4.43315 10.1099 4.69C10.3416 5.2734 10.4701 5.8926 10.4899 6.52C10.5167 5.97059 10.6107 5.42653 10.7699 4.9C10.937 4.66455 11.181 4.49479 11.4599 4.42C11.7905 4.35956 12.1293 4.35956 12.4599 4.42C12.731 4.51063 12.9681 4.68152 13.1399 4.91C13.3516 5.44035 13.4798 6.00035 13.5199 6.57C13.5199 6.71 13.5899 6.18 13.8099 5.83C13.9242 5.4906 14.2109 5.23797 14.562 5.16728C14.9131 5.09659 15.2752 5.21857 15.512 5.48728C15.7488 5.75599 15.8242 6.1306 15.7099 6.47C15.7099 7.12 15.7099 7.09 15.7099 7.53C15.7099 7.97 15.7099 8.36 15.7099 8.73C15.6734 9.31518 15.5932 9.89681 15.4699 10.47C15.2958 10.9771 15.0536 11.4582 14.7499 11.9C14.2643 12.44 13.8631 13.0502 13.5599 13.71C13.4846 14.0378 13.451 14.3738 13.4599 14.71C13.4589 15.0206 13.4992 15.33 13.5799 15.63C13.171 15.6732 12.7587 15.6732 12.3499 15.63C11.9599 15.57 11.4799 14.79 11.3499 14.55C11.2856 14.4211 11.1539 14.3397 11.0099 14.3397C10.8658 14.3397 10.7342 14.4211 10.6699 14.55C10.4499 14.93 9.95987 15.62 9.61987 15.66C8.94987 15.74 7.56987 15.66 6.47987 15.66C6.47987 15.66 6.65987 14.66 6.24987 14.3C5.83987 13.94 5.41987 13.52 5.10987 13.24L4.26987 12.28Z",
				stroke: "black",
				strokeWidth: .75,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape_3",
				d: "M12.75 12.8259V9.37411C12.75 9.16749 12.5821 9 12.375 9C12.1679 9 12 9.16749 12 9.37411V12.8259C12 13.0325 12.1679 13.2 12.375 13.2C12.5821 13.2 12.75 13.0325 12.75 12.8259Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape_4",
				d: "M10.77 12.8246L10.75 9.37107C10.7488 9.16495 10.5799 8.99882 10.3728 9.00001C10.1657 9.00119 9.99881 9.16925 10 9.37537L10.02 12.8289C10.0212 13.035 10.1901 13.2012 10.3972 13.2C10.6043 13.1988 10.7712 13.0307 10.77 12.8246Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape_5",
				d: "M8.00001 9.37899L8.02001 12.8254C8.02121 13.0335 8.19008 13.2012 8.39719 13.2C8.60429 13.1988 8.7712 13.0291 8.76999 12.821L8.74999 9.3746C8.74879 9.1665 8.57992 8.99879 8.37281 9.00001C8.16571 9.00122 7.9988 9.1709 8.00001 9.37899Z",
				fill: "black"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_687_12162",
		x: .191211,
		y: .0117874,
		width: 16.746,
		height: 17.8588,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .4 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_687_12162"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_687_12162",
				result: "shape"
			})
		]
	}) })]
});
export default SvgCursorDrag;
